import { render, staticRenderFns } from "./MSelectPayment.vue?vue&type=template&id=5b9a0378&"
import script from "./MSelectPayment.vue?vue&type=script&lang=ts&"
export * from "./MSelectPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports